import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type Podcast = WithLegacy<{
  podcastindexId: number | null;
  title: string | null;
  author: string | null;
  description: string | null;
  artworkUrl: string | null;
  feedUrl: string | null;
  language: string | null;
  extractedEpisodeCount: number | null;
  episodeCount: number | null;
  lastUpdatedAt: string | null;
  firstSeenAt: string | null;
  lastSeenAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  [Type]: 'podcasts';
}>;

export const PodcastSchema = withDefaults({
  type: 'podcasts',
  fields: [
    { name: 'podcastindexId', kind: 'attribute', type: 'number' },
    { name: 'title', kind: 'attribute', type: 'string' },
    { name: 'author', kind: 'attribute', type: 'string' },
    { name: 'description', kind: 'attribute', type: 'string' },
    { name: 'artworkUrl', kind: 'attribute', type: 'string' },
    { name: 'feedUrl', kind: 'attribute', type: 'string' },
    { name: 'language', kind: 'attribute', type: 'string' },
    { name: 'extractedEpisodeCount', kind: 'attribute', type: 'number' },
    { name: 'episodeCount', kind: 'attribute', type: 'number' },
    { name: 'lastUpdatedAt', kind: 'attribute', type: 'string' },
    { name: 'firstSeenAt', kind: 'attribute', type: 'string' },
    { name: 'lastSeenAt', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    {
      name: 'episodes',
      kind: 'hasMany',
      type: 'content-sources',
      options: { async: true, inverse: null },
    },
  ],
});
